import { useNavigate } from "react-router-dom";

/** Uniform service card: exact poster photo + title/tagline; navigates to the service's own pricing page. */
export const ServiceCard = ({ service }) => {
  const navigate = useNavigate();
  const hint = "Se priser";

  return (
    <button
      type="button"
      data-testid={`service-cta-${service.id}`}
      onClick={() => navigate(`/priser/${service.id}`)}
      aria-label={service.title}
      className="rs-tile group flex w-full flex-col overflow-hidden rounded-xl border border-[color:var(--rs-border)] bg-[color:var(--rs-panel)] text-center outline-none transition-all duration-500 hover:-translate-y-1 hover:border-[color:var(--rs-gold)] hover:shadow-[0_0_28px_-10px_rgba(212,175,55,0.6)]"
    >
      <div className="relative w-full overflow-hidden">
        <img
          src={service.image}
          alt={service.title}
          data-testid={`service-card-${service.id}`}
          className="block h-36 w-full object-cover align-top sm:h-40"
          loading="lazy"
        />
      </div>

      <div className="flex flex-1 flex-col items-center px-3 pb-6 pt-4 sm:px-4">
        <h3 className="font-heading text-lg font-medium tracking-wide text-[color:var(--rs-gold)] sm:text-xl">
          {service.title}
        </h3>
        <p className="mt-2 flex-1 text-xs leading-relaxed text-[color:var(--rs-muted)] sm:text-sm">
          {service.tagline}
        </p>
        <span className="mt-4 inline-block rounded-full border border-[color:var(--rs-gold)]/50 px-5 py-1.5 text-[10px] uppercase tracking-[0.2em] text-[color:var(--rs-gold)] transition-colors duration-300 group-hover:bg-[color:var(--rs-gold)] group-hover:text-[#0A0A0A] sm:text-xs">
          {hint}
        </span>
      </div>
    </button>
  );
};
